<template>
  <div class="Box">
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="ID">
              <el-input v-model="queryParams.id" @change="search" @clear="search" placeholder="请输入ID"
                clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="模板说明">
              <el-input v-model="queryParams.name" @change="search" @clear="search" placeholder="请输入模板说明"
                clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="创建时间">
              <el-date-picker style="width: 100%" v-model="valuetimr" type="daterange" align="right" unlink-panels
                start-placeholder="开始时间" end-placeholder="结束时间" @change="handTime" @clear="search" clearable>
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" @click="search">查询</el-button>
              <el-button @click="addNoNe">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" type="primary" @click="addrouter">返回</el-button>
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addList">添加</el-button>
        <!--				<el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
      </div>
      <!-- <div></div> -->
      <el-table ref="multipleTable" :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }"
        :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" border
        v-loading="loading">
        <el-table-column label="ID" width="80">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column prop="name" label="模板说明">
          <template slot-scope="scope"> {{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="name" label="模板预览" width="150">
          <template slot-scope="scope">
            <!-- <el-popover placement="right" width="700" :offset="10" trigger="hover"
              v-if="scope.row.w_recharge_gear != null">
              <div style="padding: 0;width: 100%;height: 100%;background-color: #eee;">
              <div class="wai" style="display: flex;margin-left: -15px;">
                <div class="PreviewBox" style="align-self: flex-start">
                  <div class="btnAdDanjuitem" v-for="(item, index) in scope.row.recharge_gear" :key="index"
                    v-if="item.recharge_type == 2">
                    <div class="left" v-if="item.description">
                      <div class="left_top" style="margin-top: 8px;font-size: 20px;font-weight: bold;color: #fff;">
                        解锁本剧<span style="color: #f9da63;">全集</span></div>
                      <div class="left_btn" style="margin-top: 0px;color: #f7d5dd;">{{
                        item.description }}</div>

                    </div>
                    <div class="left" v-else>
                      <div class="" style="margin-top: 14px;font-size: 20px;font-weight: bold;color: #fff;">
                        解锁本剧 <span>全集</span></div>

                    </div>
                    <div class="right">¥<span style="font-weight: bold;">{{ item.money }}</span>
                    </div>
                  </div>
                  <div class="btnAd" v-for="(item, index) in scope.row.recharge_gear" :key="index"
                    v-if="item.recharge_type == 1 || item.recharge_type == 0">
                    <div class="btnAd_wai"
                      :class="{ 'white-background': item.recharge_type === 0, 'black-background': item.recharge_type === 1 }">
                      <div class="price">¥ {{ item.money }}</div>
                      <div>
                        <div style="position: relative" v-if="item.recharge_type == 0">
                          <div class="bi">{{ (item.money * 100).toFixed(0) }}k币<span style="color: #ec915f;" v-if="item.free_balance > 0">+{{
                            item.free_balance ?
                              item.free_balance : 0
                              }}k币</span></div>
                          <div class="dingBtn" v-if="item.goods_mark_txt" style="background-color: #ed6c34;">{{
                            item.goods_mark_txt
                          }}
                          </div>
                        </div>
                        <div v-else style="position: relative">
                          <div class="bi">{{ item.description }}</div>
                          <div class="dingBtn" v-if="item.goods_mark_txt" style="background-color: #ed6c34;">{{
                            item.goods_mark_txt
                          }}
                          </div>
                        </div>
                      </div>

                      <div>
                        <div class="song" v-if="item.recharge_type == 0" style="background-color: #fde2e1;color: #d24757;font-weight: bold;">
                          {{
                            (item.footer_mark_txt && item.footer_mark_txt !=
                              undefined)
                              ? item.footer_mark_txt : ""
                          }}
                        </div>
                        <div class="song" style="background-color: #e44455;color: #fff;" v-else>
                          {{
                            (item.footer_mark_txt
                              && item.footer_mark_txt != undefined) ? item.footer_mark_txt
                              :
                              ""
                          }}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="PreviewBox" style="margin-left: 0px;flex-grow: 1;align-self: flex-start">
                  <div class="btnAdDanjuitem" v-for="(item, index) in scope.row.w_recharge_gear" :key="index"
                    v-if="item.recharge_type == 2">
                    <div class="left" v-if="item.description">
                      <div class="left_top" style="margin-top: 8px;font-size: 20px;font-weight: bold;color: #fff;">
                        解锁本剧<span style="color: #f9da63;">全集</span></div>
                      <div class="left_btn" style="margin-top: 0px;color: #f7d5dd;">{{
                        item.description }}</div>

                    </div>
                    <div class="left" v-else>
                      <div class="" style="margin-top: 14px;font-size: 20px;font-weight: bold;color: #fff;">
                        解锁本剧 <span>全集</span></div>

                    </div>
                    <div class="right">¥<span style="font-weight: bold;">{{ item.money }}</span>
                    </div>
                  </div>
                  <div class="btnAd" v-for="(item, index) in scope.row.w_recharge_gear" :key="index"
                    v-if="item.recharge_type == 1 || item.recharge_type == 0">
                    <div class="btnAd_wai"
                      :class="{ 'white-background': item.recharge_type === 0, 'black-background': item.recharge_type === 1 }">
                      <div class="price">¥ {{ item.money }}</div>
                      <div>
                        <div style="position: relative" v-if="item.recharge_type == 0">
                          <div class="bi">{{ (item.money * 100).toFixed(0) }}k币<span style="color: #ec915f;" v-if="item.free_balance > 0">+{{
                            item.free_balance ?
                              item.free_balance : 0
                              }}k币</span></div>
                          <div class="dingBtn" v-if="item.goods_mark_txt" style="background-color: #ed6c34;">{{
                            item.goods_mark_txt
                          }}
                          </div>
                        </div>
                        <div v-else style="position: relative">
                          <div class="bi">{{ item.description }}</div>
                          <div class="dingBtn" v-if="item.goods_mark_txt" style="background-color: #ed6c34;">{{
                            item.goods_mark_txt
                          }}
                          </div>
                        </div>
                      </div>

                      <div>
                        <div class="song" v-if="item.recharge_type == 0" style="background-color: #fde2e1;color: #d24757;font-weight: bold;">
                          {{
                            (item.footer_mark_txt && item.footer_mark_txt !=
                              undefined)
                              ? item.footer_mark_txt : ""
                          }}
                        </div>
                        <div class="song" style="background-color: #e44455;color: #fff;" v-else>
                          {{
                            (item.footer_mark_txt
                              && item.footer_mark_txt != undefined) ? item.footer_mark_txt
                              :
                              ""
                          }}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
              <el-link type="primary" slot="reference" @mouseover="Preview(scope.row)">预览</el-link>
            </el-popover>
            <el-popover placement="right" width="356" trigger="hover" v-else>
              <div style="padding: 0;width: 100%;height: 100%;background-color: #eee;">
              <div class="wai" style="display: flex;margin-left: -15px;">
                <div class="PreviewBox">
                  <div class="btnAdDanjuitem" v-for="(item, index) in scope.row.recharge_gear" :key="index"
                    v-if="item.recharge_type == 2">
                    <div class="left" v-if="item.description">
                      <div class="left_top" style="margin-top: 8px;font-size: 20px;font-weight: bold;color: #fff;">
                        解锁本剧<span style="color: #f9da63;">全集</span></div>
                      <div class="left_btn" style="margin-top: 0px;color: #f7d5dd;">{{
                        item.description }}</div>

                    </div>
                    <div class="left" v-else>
                      <div class="" style="margin-top: 14px;font-size: 20px;font-weight: bold;color: #fff;">
                        解锁本剧 <span>全集</span></div>

                    </div>
                    <div class="right">¥<span style="font-weight: bold;">{{ item.money }}</span>
                    </div>
                  </div>
                  <div class="btnAd" v-for="(item, index) in scope.row.recharge_gear" :key="index"
                    v-if="item.recharge_type == 1 || item.recharge_type == 0">
                    <div class="btnAd_wai"
                      :class="{ 'white-background': item.recharge_type === 0, 'black-background': item.recharge_type === 1 }">
                      <div class="price">¥ {{ item.money }}</div>
                      <div>
                        <div style="position: relative" v-if="item.recharge_type == 0">
                          <div class="bi">{{ (item.money * 100).toFixed(0) }}k币<span style="color: #ec915f;" v-if="item.free_balance > 0">+{{
                            item.free_balance ?
                              item.free_balance : 0
                              }}k币</span></div>
                          <div class="dingBtn" v-if="item.goods_mark_txt" style="background-color: #ed6c34;">{{
                            item.goods_mark_txt
                          }}
                          </div>
                        </div>
                        <div v-else style="position: relative">
                          <div class="bi">{{ item.description }}</div>
                          <div class="dingBtn" v-if="item.goods_mark_txt" style="background-color: #ed6c34;">{{
                            item.goods_mark_txt
                          }}
                          </div>
                        </div>
                      </div>

                      <div>
                        <div class="song" v-if="item.recharge_type == 0" style="background-color: #fde2e1;color: #d24757;font-weight: bold;">
                          {{
                            (item.footer_mark_txt && item.footer_mark_txt !=
                              undefined)
                              ? item.footer_mark_txt : ""
                          }}
                        </div>
                        <div class="song" style="background-color: #e44455;color: #fff;" v-else>
                          {{
                            (item.footer_mark_txt
                              && item.footer_mark_txt != undefined) ? item.footer_mark_txt
                              :
                              ""
                          }}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>
              <el-link type="primary" slot="reference" @mouseover="Preview(scope.row)">预览</el-link>
            </el-popover> -->
            <el-link type="primary" slot="reference" @click="Preview(scope.row)">预览</el-link>
          </template>

        </el-table-column>
        <el-table-column prop="name" label="模板标签" width="120">
          <!-- <template slot-scope="scope"> -->
          <template slot-scope="scope"> {{ scope.row.recharge_tag_text }}</template>
          <!-- <span v-if="scope.row.status == 0">默认</span>
            <span v-if="scope.row.status == 1">完成</span> -->
          <!-- </template> -->
        </el-table-column>

        <el-table-column prop="name" label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">无效</span>
            <span v-if="scope.row.status == 1">有效</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="创建人" width="120">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.admin_type_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="创建时间">
          <template slot-scope="scope">{{ scope.row.created_at }}</template>
        </el-table-column>

        <el-table-column prop="name" label="更新时间">
          <template slot-scope="scope">{{ scope.row.updated_at }}</template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="addEdit(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.status == 1" type="text" size="medium" @click="addStatus(scope.row)">禁用
            </el-button>
            <el-button type="text" v-if="scope.row.status == 0" size="medium" @click="addopen(scope.row)">开启
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
        @pagination="getList" />
      <RechargeTemplate v-if="RechargeFlag" :RechargeFlag="RechargeFlag" :paramsMovie="paramsMovie" :islook="islook" :id="id"
        @RechargeNone="RechargeNone">
      </RechargeTemplate>
    </el-card>
  </div>
</template>

<script>
import { RechargeAPI } from '@/api/popularize/Recharge';
import RechargeTemplate from './component/RechargeTemplate.vue';
import { processErrors } from "@/utils/errorHandler";

export default {
  components: {
    RechargeTemplate,
  },
  data() {
    return {
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        id: '',
        name: '',
        st: '',
        et: '',
      },
      popoverVisible: false,
      valuetimr: '',
      appidList: [],

      tableData: [],
      multipleSelection: [],
      editID: '',
      // 总条数
      total: 0,
      SearchFlag: false,
      RechargeFlag: false,
      paramsMovie: {
        movie_id: '',
        movie_Name: '',
      },
      id: '',
      CZOne: [],
      CZTwo: [],
      loading: false,
      islook:false,
    };
  },
  created() {
    this.getList();
    let obj = JSON.parse(localStorage.getItem('movie'));
    this.paramsMovie.movie_id = obj.movie_id;
    this.paramsMovie.movie_Name = obj.movie_Name;
  },
  methods: {
    Preview(row) {
      // this.CZOne = []
      // this.CZTwo = []
      // this.CZOne = row.recharge_gear.filter(item => item.recharge_type === 0 || item.recharge_type === 1);
      // if (row.w_recharge_gear) {
      //   this.CZTwo = row.w_recharge_gear.filter(item => item.recharge_type === 0 || item.recharge_type === 1);
      // } else {
      //   this.CZTwo = []

      // }
      // const api = RechargeAPI();
      // api.goods_rechargeinfo(row.id).then((response) => {
      //   this.CZOne = response.data.recharge_gear.filter(item => item.recharge_type === 0 || item.recharge_type === 1);
      //   if (response.data.w_recharge_gear) {

      //     this.CZTwo = response.data.w_recharge_gear.filter(item => item.recharge_type === 0 || item.recharge_type === 1);
      //   } else {
      //     this.CZTwo = []

      //   }

      // })
let obj = JSON.parse(localStorage.getItem('movie'));
this.islook = true
      if (obj) {
        this.paramsMovie.movie_id = obj.movie_id;
        this.paramsMovie.movie_Name = obj.movie_Name;
        this.id = row.id;
        this.RechargeFlag = true;
      } else {
        // 	this.paramsMovie.movie_id = obj.movie_id
        // this.paramsMovie.movie_Name = obj.movie_Name
        this.id = row.id;
        this.RechargeFlag = true;
      }

    },
    hidePopover() {
      this.popoverVisible = false; // 隐藏弹出框
    },
    getList() {
      this.loading = true
      let api = RechargeAPI();
      api.getRechargeList(this.queryParams).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.total = res.data.totalCount;
        } else {
          processErrors(res);
        }
        this.loading = false
      });
    },

    handTime(e) {
      const date = e[0];
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const day = ('0' + date.getDate()).slice(-2) - 1;
      const formattedDate = `${year}-${month}-${day}`;

      const dates = e[1];
      const years = dates.getFullYear();
      const months = ('0' + (dates.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
      const days = ('0' + dates.getDate()).slice(-2) - 1;
      const formattedDates = `${years}-${months}-${days}`;
      this.queryParams.st = formattedDate;
      this.queryParams.et = formattedDates;
      this.getList();
    },
    // 打开搜索
    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true;
      } else {
        this.SearchFlag = false;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 搜索
    search() {
      this.getList();
    },
    // 重置列表
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
      };
      this.getList();
    },
    // 新增按钮事件
    addList() {
      this.id = '';
      this.islook = false
      this.RechargeFlag = true;
    },
    addopen(row) {
      this.$confirm('确定开启该模板吗 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let api = RechargeAPI();
          let obj = {
            id: row.id,
            status: 1,
          };
          api.statusRecharge(obj).then((res) => {
            // 假设 DelList 接受一个 id，而不是数组
            if (res.code == 0) {
              this.getList();
              this.$message({
                message: '开启成功',
                type: 'success',
              });
            } else {
              processErrors(res);
            }
          });
        })
        .catch(() => {
          this.$message({
            message: '取消删除',
            type: 'info', // 使用 'info' 类型表示提示信息
          });
        });
    },
    addEdit(row) {
      let obj = JSON.parse(localStorage.getItem('movie'));
      this.islook = false
      if (obj) {
        this.paramsMovie.movie_id = obj.movie_id;
        this.paramsMovie.movie_Name = obj.movie_Name;
        this.id = row.id;
        this.RechargeFlag = true;
      } else {
        // 	this.paramsMovie.movie_id = obj.movie_id
        // this.paramsMovie.movie_Name = obj.movie_Name
        this.id = row.id;
        this.RechargeFlag = true;
      }
    },
    RechargeNone() {
      this.getList();
      this.RechargeFlag = false;
    },
    addrouter() {
      this.$router.go(-1);
    },
    addStatus(row) {
      this.$confirm('确定禁用该模板吗 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let api = RechargeAPI();
          let obj = {
            id: row.id,
            status: 0,
          };
          api.statusRecharge(obj).then((res) => {
            // 假设 DelList 接受一个 id，而不是数组
            if (res.code == 0) {
              this.getList();
              this.$message({
                message: '禁用成功',
                type: 'success',
              });
            } else {
              processErrors(res);
            }
          });
        })
        .catch(() => {
          this.$message({
            message: '取消删除',
            type: 'info', // 使用 'info' 类型表示提示信息
          });
        });
    },
  },

  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.Box {
  & ::v-deep el-card__body {
    padding: 0 !important;
  }
}

.btnAdDanjuitem {
  padding: 0;
  display: flex;
  margin-left: 16px;
  background-image: url('../../../assets/微信图片_20240910174026.png');
  background-size: cover;
  // /* 使背景图覆盖整个容器 */
  background-position: center;
  // /* 背景图居中对齐 */
  background-repeat: no-repeat;
  /* 背景图不重复 */
  // height: 100vh;
  /* 高度覆盖视口高度 */
  width: 314px;
  margin-bottom: 20px;
  height: 70px;
  border: #ccc 1px solid;
  border-radius: 10px;
  position: relative;
  overflow: hidden;

  .left {
    // display: flex;
    // flex-direction: column;
    width: 230px;
    // height: 80px;
    // line-height: 70px;
    text-align: center;
    // line-height: 30px;
  }

  .right {
    width: 100px;
    line-height: 70px;
    text-align: center;
    color: #e44663;

    span {
      font-size: 18px;
      color: #e44663;
      text-align: center;
    }
  }

  .right_jiao {
    height: 10px;
    position: absolute;
    right: 0px;

    top: -20px;
    // width: 40px;
    font-size: 11px;

    .jiao {
      color: #fff;
      margin-top: 9px;
      padding: 2px 10px 2px 16px;
      background-color: #ed6e33;
      // width: 80px;
      text-align: center;
      height: 30px;
      border-bottom-left-radius: 20px;
    }
  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.PreviewBox {
  width: 800px;
  // height: 300px;
  display: flex;
  // justify-content: space-around;
  flex-wrap: wrap;
  padding: 4px;

  .white-background {
    background-color: #fff;
  }

  .black-background {

    background-color: white;
    background-image: url('../../../assets/zhuan.png');
    background-size: cover;
    /* 使背景图覆盖整个容器 */
    background-position: center;
    /* 背景图居中对齐 */
    background-repeat: no-repeat;
    //  背景图不重复
    height: 100vh;
  }

  .btnAd {
    width: 150px;
    height: 110px;
    // border: #ccc 1px solid;
    border-radius: 10px;
    // margin-top: 10px;
    padding: 0px;
    margin-left: 16px;

    .btnAd_wai {
      border-radius: 10px;
      width: 150px;
      height: 100px;

      .price {
        height: 20px;
        font-size: 15px;
        line-height: 60px;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
      }

      .bi {
        font-size: 10px;
        margin-top: 23px;
        // margin-top: 6px;
        text-align: center;
      }

      .dingBtn {
        position: absolute;
        top: -43px;
        right: 0px;
        height: 20px;
        // width: 40px;
        background-color: antiquewhite;
        line-height: 18px;
        text-align: center;
        padding: 2px 6px;
        background-color: #1890ff;
        color: #fff;
        border: 1px solid #ed6e33;
        border-top-right-radius: 7px;
        border-bottom-left-radius: 10px;
        font-size: 11px;
      }

      .song {
        margin: auto;
        width: 100%;
        line-height: 29px;
        text-align: center;
        font-size: 13px;
        margin-top: 15px;
        background-color: #1890ff;
        // border-radius: 10px;
        color: #fff;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }
    }
  }
}

.Coimage {
  width: 50px;
  height: 50px;
}
</style>
